import React from "react";
import styled from "styled-components";
import axios from "axios";
import { BASE_URL } from "../../constants";

import { Link } from "react-router-dom";
import { TextField } from "redux-form-material-ui";
import Dialog from "material-ui/Dialog";
// import Button from "material-ui/FlatButton";
import Button from "material-ui/RaisedButton";

// Styed components
const Text = styled.div`
  line-height: 25px;
  margin-bottom: 15px;
  margin-top: 15px;
`;

const Status = styled.div`
  padding: 15px 0;
  text-align: center;
  color: ${({ isError }) => (isError ? "red" : "green")};
  font-weight: 600;
`;

const FormWrap = styled.div`
  display: flex;
  flex-direction: column;
`;

const muiStyles = {
  inputStyle: {
    fontWeight: "400",
    fontFamily: '"Montserrat", sans-serif'
  }
};

// TODO Centralize this email validation in an util
// http://stackoverflow.com/a/46181/2213882
function isValidEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

const defaultModalMessage = {
  header: "Hey! 😃",
  message:
    "Thank you for your interest in CATCHTRIPS. Our limited release period is over, and we are no longer accepting new bookings at this time."
};

class TrialPeriodOverModal extends React.Component {
  state = {
    status: "initial",
    open: false,
    inputValue: "",
    errorMessage: "",
    submitButtonEnabled: false,
    modalMessage: defaultModalMessage
  };

  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmitButtonClick = this.handleSubmitButtonClick.bind(this);
  }

  handleInputChange(e) {
    const inputValue = e.target.value;
    const submitButtonEnabled = isValidEmail(inputValue);
    this.setState({ inputValue, submitButtonEnabled });
  }

  handleSubmitButtonClick() {
    const url = `${BASE_URL}/email/waitinglist`;
    const email = this.state.inputValue;
    const payload = {
      email
    };

    this.setState({ submitButtonEnabled: false });

    axios
      .post(url, payload)
      .then(_ => {
        this.setState({
          submitButtonEnabled: false,
          status: "success"
        });
      })
      .catch(e => {
        this.setState({ errorMessage: e.message, status: "error" });
      });
  }

  componentDidMount() {
    const url = `${BASE_URL}/config/clientappaccess`;
    const payload = {
      id: "preventClientAppAccess"
    };
    // Get latest FlightLookup info from PPN
    axios
      .post(url, payload)
      .then(response => {
        const { data } = response.data;
        this.setState({
          open: data.openModal,
          modalMessage: data.message ? data : defaultModalMessage // If message is null from server, then show default message in component
        });
      })
      .catch(err => {
        // this.setState({ fetchError: err });
      });
  }

  render() {
    let renderStatus;
    const { modalMessage } = this.state;

    if (this.state.status !== "initial") {
      if (this.state.status === "error") {
        renderStatus = (
          <Status isError={true}>There was a problem sending the email.</Status>
        );
      } else {
        renderStatus = <Status>Email was sent successfully!</Status>;
      }
    }
    return (
      <Dialog
        title={modalMessage.header}
        autoScrollBodyContent={true}
        open={this.state.open}
      >
        <Text>{modalMessage.message}</Text>
        <Text>
          If you purchased a ticket previously, you can check the status of your
          flight reservation <Link to={"/find-my-trip"}>here</Link>.
        </Text>
        <Text>Please enter your email below to receive updates.</Text>
        <FormWrap>
          <TextField
            name="customerEmail"
            floatingLabelText="Enter your email"
            onChange={this.handleInputChange}
            value={this.state.inputValue}
            hintStyle={muiStyles.inputStyle}
            inputStyle={muiStyles.inputStyle}
            floatingLabelStyle={muiStyles.inputStyle}
            fullWidth
          />
          <Button
            label={this.state.status === "success" ? "Sent!" : "Submit"}
            primary
            onClick={this.handleSubmitButtonClick}
            disabled={!this.state.submitButtonEnabled}
          />
          {renderStatus}
        </FormWrap>
      </Dialog>
    );
  }
}

export default TrialPeriodOverModal;



// WEBPACK FOOTER //
// ./src/components/TrialPeriodOverModal/index.js